import React, { useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';
import { Form} from 'antd';
import { useSnackbar } from 'notistack';
import api from '@http/api';
import TableNoPagination from '../../../Tables/TableBoletoNoPagination';

interface IProps {
  idPerfil: number;
}

export interface ILista {
  documentoDescricao: string;
  ano: string;
  nomeProjeto: string;
}

const columnsLabel = {
  documentoDescricao: 'Documento',
  nomeProjeto: 'Projeto',
  ano: 'ano',
};

const optionsFilter = ['ID', 'CPF/CNPJ'];

const ModalPendencia:React.FC<IProps> = ({
  idPerfil,

}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ILista[]>([]);


  async function loadDocumentosPendentesIR() {
    setLoading(true);
     try {
      const response = await api.get(`/api/DocumentacaoProjetoIr/GetPendentesByPerfil/${idPerfil}`)


      const items = response.data.documentos || [];
      if (items.length > 0) {

        const itemData: ILista[] = items.map((item: ILista) => ({
          nomeProjeto: item.nomeProjeto,
          documentoDescricao: item.documentoDescricao,
          ano: item.ano,
        }));

        setData(itemData);
        setLoading(false);
      } else {
        setData([]);
        enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
          variant: 'info',
        });
      }
    } catch (error) {
      console.error('Erro ao carregar doações:', error);
      setData([]);

    } finally {
      setLoading(false);
    }
  }

useEffect(() => {
  loadDocumentosPendentesIR();
}, []);


 return (
  <Grid container>
    <Grid item lg={12}>
    <TableNoPagination
        loading={loading}
        columns={[columnsLabel]}
        FieldsBold={[]}
        data={data}
        keys={[
          'nomeProjeto',
          'documentoDescricao',
          'ano'
        ]}


       />
    </Grid>
</Grid>
  );
};

export default ModalPendencia;
